import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QmsDataTable } from "../_common/QmsDataTable";
import cmtCategoryActions from "../../../_actions/_qmsActions/cmtCategoryActions";
import QmsAdminModal_EditCmtCategory from "./QmsAdminModal_EditCmtCategory";

export default function QmsAdminCmtCategories(props) {
  const { divisionId } = props;

  const dispatch = useDispatch();
  useEffect(() => dispatch(cmtCategoryActions.getAll(divisionId)), [divisionId]);

  const cmtCategories = useSelector(
    (state) => state.qms.cmtCategories[divisionId] || null
  );

  const columns = useRef([
    {
      id: "label",
      numeric: false,
      disablePadding: true,
      label: "Category Label",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Category Description",
    },
  ]);

  return (
    <QmsDataTable
      data={cmtCategories}
      columns={columns.current}
      idName="cmtCategoryId"
      editModalComponent={<QmsAdminModal_EditCmtCategory divisionId={divisionId} />}
      onDelete={(ids) => dispatch(cmtCategoryActions.removeRange(ids, divisionId))}
      isExpandable={false}
    />
  );
}
